module.exports = __webpack_public_path__ + "img/23_74.999ee77a.png";